import { useRef, FormEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InputRef from "../../../../../interfaces/InputRef";
import ButtonSubmit from "../../../../parts/ButtonSubmit";
import InputDate from "../../../../parts/InputDate";
import InputText from "../../../../parts/InputText";
import RequiredMark from "../../../../parts/RequiredMark";
import { VacationScoutCensusSummaryForm } from "./VacationScoutCensusSummaryForm";
import { Census } from "../../../../../model/census";

interface VacationScoutCensusProps {
    census: Census | undefined;
}

function VacationScoutCensus(props: VacationScoutCensusProps) {
    const navigate = useNavigate();
    const loc = useLocation();
    const data: VacationScoutCensusSummaryForm | null = loc.state?.data ?? fillFromCneus(props.census);

    const vacationStartDateRef = useRef<InputRef>();
    const vacationEndDateRef = useRef<InputRef>();
    const commentRef = useRef<InputRef>();

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();

        if (
            vacationStartDateRef.current?.validate()
            && vacationEndDateRef.current?.validate()
            && commentRef.current?.validate()
        ) {
            const data = new VacationScoutCensusSummaryForm({
                comment: commentRef.current?.value() ?? '',
                startDate: vacationStartDateRef.current?.value() ?? '',
                endDate: vacationEndDateRef.current?.value() ?? '',
            })
            navigate("/scout-census/summary/vacation", { state: { data: data } });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <InputDate
                ref={vacationStartDateRef}
                initValue={data?.startDate ?? ""} 
                label={'Data rozpoczęcia urlopu'}
                isRequired={true}
            />
            <InputDate
                ref={vacationEndDateRef}
                label={'Data zakończenia urlopu'}
                isRequired={true}
                initValue={data?.endDate ?? ""} 
            />
            <InputText
                ref={commentRef}
                label={'Uwagi'}
                placeholderText={'miejsce na twoje dodatkowe uwagi'}
                isRequired={false}
                rows={3}
                maxLength={500}
                initValue={data?.comment ?? ""} 
            />
            <RequiredMark withDescription />
            <ButtonSubmit text="Wyślij prośbę o urlop" />
        </form>
    );
}

export default VacationScoutCensus;

function fillFromCneus(census: Census | undefined): VacationScoutCensusSummaryForm | null {
    if(!census)
        return null;

    return new VacationScoutCensusSummaryForm({
        comment: census.RegistrantComment,
        startDate: census.VacationStartDate ?? "",
        endDate: census.VacationEndDate ?? "",
    })
}
